import { Form, Formik, FormikProps } from 'formik';
import * as React from 'react';
import { connect } from 'react-redux';

import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';
import InputAdornment from '@material-ui/core/InputAdornment';
import TextField from '@material-ui/core/TextField';
import Visibility from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';

import { withDefaultStyles } from '../../../utils/material-ui/hoc';

class SsoForm extends React.Component<any, any> {
    public render() {
        return (
            <div style={this.props.style}>
                <Formik
                    initialValues={{
                        accountId: this.props.auth.accountId,
                        token: this.props.auth.token,
                    }}
                    onSubmit={this.props.onSubmit}
                    render={this.form}
                    enableReinitialize={true}
                />
            </div>
        );
    }
    private form = (p: FormikProps<any>) => <Form>
        <TextField
            required={true}
            label="Account Id"
            type="text"
            name="accountId"
            InputLabelProps={{
                shrink: true,
            }}
            margin="normal"
            variant="outlined"
            placeholder="Account Id"
            fullWidth={true}
            value={p.values.accountId}
            onChange={p.handleChange}
            onBlur={p.handleBlur}
        />
        <TextField
            required={true}
            label="Service Access Token"
            type={this.props.auth.showToken ? 'text' : 'password'}
            name="token"
            InputLabelProps={{
                shrink: true,
            }}
            margin="normal"
            variant="outlined"
            placeholder="Access Token"
            fullWidth={true}
            value={p.values.token}
            onChange={p.handleChange}
            onBlur={p.handleBlur}
            InputProps={{
                endAdornment: <InputAdornment position="end">
                    <IconButton aria-label="Toggle password visibility" onClick={this.props.handleShowToken}>
                        {this.props.auth.showToken ? <Visibility /> : <VisibilityOff />}
                    </IconButton>
                </InputAdornment>,
            }}
        />
        <Button style={{width: '100%'}} type="submit" color="primary">Update</Button>
    </Form>
}


const mapStateToProps = (state, ownProps) => {
    return { ...state };
}

export default withDefaultStyles(connect(
    mapStateToProps,
)(SsoForm));



// WEBPACK FOOTER //
// ./src/sub-projects/roostify/components/sso-form.tsx